// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".job-lang-skill--header[data-v-0b5ce2a9]{margin-bottom:.5rem}.job-lang-skill--header h5[data-v-0b5ce2a9]{font-weight:500}@media (max-width:959px){.job-lang-skill__level-excellent[data-v-0b5ce2a9]{margin-right:.25rem}}@media (min-width:960px){.job-lang-skill--header h5[data-v-0b5ce2a9]{font-size:1.0625rem}}", ""]);
// Exports
module.exports = exports;
